export default {
  methods: {
    createBodyMessage ({mail, threadId, boundary}) {
      const lineBreak = '\r\n'
      const body = [
        '--' + boundary,
        'Content-Type: application/json; charset=UTF-8' + lineBreak,
        '{',
        '', // index 3
        '}' + lineBreak,
        '--' + boundary,
        'Content-Type: message/rfc822' + lineBreak,
        mail,
        '--' + boundary + '--'
      ]
      if (threadId) body[3] = `"threadId": "${threadId}"`
      return body.join(lineBreak)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/createBodyMessage.js